import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestlandingComponent } from './testlanding/testlanding.component';
import { ButtonModule } from 'primeng/button';
import {PanelMenuModule} from 'primeng/panelmenu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { CreateJobChainComponent } from './jobs/create-job-chain/create-job-chain.component';
import { AllJobsComponent } from './jobs/all-jobs/all-jobs.component';
import {TableModule} from 'primeng/table';
import { HttpClientModule } from '@angular/common/http';
import { ProductService } from './services/productservice';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule} from '@angular/forms';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {DragDropModule} from 'primeng/dragdrop';
import {OrderListModule} from 'primeng/orderlist';
import { MyJobRequestComponent } from './jobs/my-job-request/my-job-request.component';
import { CreateJobRequestComponent } from './jobs/create-job-request/create-job-request.component';
import { ReviewJobRequestComponent } from './jobs/review-job-request/review-job-request.component';
import { AllJobChainsComponent } from './jobs/all-job-chains/all-job-chains.component';
import { AllTemplatesComponent } from './templates/all-templates/all-templates.component';
import { CreateTemplateComponent } from './templates/create-template/create-template.component';
import { CompaniesComponent } from './masterdata/companies/companies.component';
import { DepartmentsComponent } from './masterdata/departments/departments.component';
import { EmployeesComponent } from './masterdata/employees/employees.component';
import { JobTypesComponent } from './masterdata/job-types/job-types.component';
import { JobCategoriesComponent } from './masterdata/job-categories/job-categories.component';
import { BudgetComponent } from './masterdata/budget/budget.component';
import { VehiclesComponent } from './masterdata/vehicles/vehicles.component';
import { AllBudgetRequestsComponent } from './budget/all-budget-requests/all-budget-requests.component';
import { MyBudgetRequestsComponent } from './budget/my-budget-requests/my-budget-requests.component';
import { BudgetStatusComponent } from './budget/budget-status/budget-status.component';
import { ReviewBudgetRequestsComponent } from './budget/review-budget-requests/review-budget-requests.component';
import { BudgetConsumptionReportComponent } from './reports/budget-consumption-report/budget-consumption-report.component';
import { JobChainCycleReportComponent } from './reports/job-chain-cycle-report/job-chain-cycle-report.component';
import { AccountSettinngsComponent } from './settings/account-settinngs/account-settinngs.component';
import { AddCompanyComponent } from './masterdata/add-company/add-company.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {SelectItem} from 'primeng/api';
import {SelectItemGroup} from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import {FileUploadModule} from 'primeng/fileupload';
import { TimelineModule } from "primeng/timeline";
import { CardModule } from "primeng/card";
import { AccordionModule } from 'primeng/accordion';
import { BudgetRequestDetailsComponent } from './budget/budget-request-details/budget-request-details.component';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import {ProgressBarModule} from 'primeng/progressbar';
import {ToastModule} from 'primeng/toast';
import {PaginatorModule} from 'primeng/paginator';
import {SidebarModule} from 'primeng/sidebar';
import { AddVehicleComponent } from './masterdata/add-vehicle/add-vehicle.component';
import { CalendarModule } from 'primeng/calendar';
import { JobRequestDetailsComponent } from './jobs/job-request-details/job-request-details.component';
import { AddBudgetAllocationComponent } from './budget/add-budget-allocation/add-budget-allocation.component';
import { BudgetAllocationsComponent } from './budget/budget-allocations/budget-allocations.component';
import {ChartModule} from 'primeng/chart';


@NgModule({
  declarations: [
    AppComponent,
    TestlandingComponent,
    CreateJobChainComponent,
    AllJobsComponent,
    MyJobRequestComponent,
    CreateJobRequestComponent,
    ReviewJobRequestComponent,
    AllJobChainsComponent,
    AllTemplatesComponent,
    CreateTemplateComponent,
    CompaniesComponent,
    DepartmentsComponent,
    EmployeesComponent,
    JobTypesComponent,
    JobCategoriesComponent,
    BudgetComponent,
    VehiclesComponent,
    AllBudgetRequestsComponent,
    MyBudgetRequestsComponent,
    BudgetStatusComponent,
    ReviewBudgetRequestsComponent,
    BudgetConsumptionReportComponent,
    JobChainCycleReportComponent,
    AccountSettinngsComponent,
    AddCompanyComponent,
    BudgetRequestDetailsComponent,
    AddVehicleComponent,
    JobRequestDetailsComponent,
    AddBudgetAllocationComponent,
    BudgetAllocationsComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ButtonModule,
    PanelMenuModule,
    MenuModule,
    RippleModule,
    TableModule,
    HttpClientModule,
    InputTextModule,
    FormsModule,
    BreadcrumbModule,
    DragDropModule,
    OrderListModule,
    InputSwitchModule,
    DropdownModule,
    FileUploadModule,
    TimelineModule,
    CardModule,
    AccordionModule,
    DialogModule,
    CheckboxModule,
    TagModule,
    ProgressBarModule,
    PaginatorModule,
    ToastModule,
    SidebarModule,
    CalendarModule,
    ChartModule
    
  ],
  providers: [ProductService],
  bootstrap: [AppComponent]
})
export class AppModule { }
